export default __webpack_public_path__ + "static/media/Access-Health-Support_1112-x-646.6b899618.jpg";